import React from 'react';
import { useDispatch } from 'react-redux';
import { useShallowEqualSelector } from '@hooks';
import { createNetworkAffiliatePreference } from '@actions';
import classNames from 'classnames';
import { Heart as FavoriteIcon } from 'react-feather';
import { Button } from '@dotone/react-ui-core';

const AffiliateFavoriteButton = ({ affiliateId, value, ...otherProps }) => {
  const dispatch = useDispatch();
  const { isLoading } = useShallowEqualSelector(
    ({ networkAffiliatePreferenceCreate }) => networkAffiliatePreferenceCreate
  );

  const handleClick = () => {
    dispatch(createNetworkAffiliatePreference(affiliateId, { favorite: !value }));
  };

  return (
    <Button size="sm" color="link" disabled={isLoading} onClick={handleClick} {...otherProps}>
      <FavoriteIcon
        size={16}
        className={classNames({ 'text-secondary': !value, 'text-danger': value })}
        fill={value ? 'currentColor' : 'none'}
      />
    </Button>
  );
};

export default AffiliateFavoriteButton;
